import React, { useLayoutEffect, useRef, useState } from "react";

// Single-line text that steps its font size down until it fits the report page width.
export function FitOneLine({ text, max, min, reserve = 72 }) {
  const ref = useRef(null);
  const [size, setSize] = useState(max);
  useLayoutEffect(() => {
    const fit = () => {
      const el = ref.current;
      const box = el?.closest(".page-inner");
      if (!el || !box) return;
      let s = max;
      el.style.fontSize = `${s}px`;
      const avail = box.clientWidth - reserve;
      while (s > min && el.scrollWidth > avail) {
        s -= 1;
        el.style.fontSize = `${s}px`;
      }
      setSize(s);
    };
    fit();
    document.fonts?.ready?.then(fit);
  }, [text, max, min, reserve]);
  return (
    <span ref={ref} style={{ fontSize: size, whiteSpace: "nowrap", display: "inline-block" }} data-testid="report-cover-goto-name">
      {text}
    </span>
  );
}
